module.exports = __webpack_public_path__ + "static/media/video-thumbnail.d40f854c.png";